module.exports = __webpack_public_path__ + "static/media/korean3.14fc5ceb.jpeg";